"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeemarketModule = void 0;
const feemarket_1 = require("../codec/ethermint/feemarket/v1/feemarket");
const tx_1 = require("../codec/ethermint/feemarket/v1/tx");
const util_1 = require("../util");
const base_1 = __importDefault(require("./base"));
class FeemarketModule extends base_1.default {
    updateParams(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = tx_1.MsgUpdateParams.fromPartial({
                authority: params.creator,
                params: feemarket_1.Params.fromPartial({
                    noBaseFee: params.noBaseFee,
                    baseFeeChangeDenominator: params.baseFeeChangeDenominator,
                    elasticityMultiplier: params.elasticityMulitplier,
                    enableHeight: params.enableHeight,
                    baseFee: params.baseFee.toString(10),
                    minGasPrice: params.minGasPrice.toString(10),
                    minGasMultiplier: params.minGasMulitplier.toString(10),
                    gasLimitPerBlock: params.gasLimitPerBlock.toString(10),
                    maxBaseFee: params.maxBaseFee.toString(10)
                })
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgUpdateParams,
                value,
            }, opts);
        });
    }
}
exports.FeemarketModule = FeemarketModule;
